import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute} from '@angular/router';
import { StudentResourceService } from '../../_services/student-resource.service'
import { FormGroup,FormBuilder,Validators} from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-student-resource',
  templateUrl: './student-resource.component.html',
  styleUrls: ['./student-resource.component.css'],
  providers:[StudentResourceService]
})
export class StudentResourceComponent implements OnInit {
  studForm:FormGroup;
  public currentUser: any;
  public currentUserName: any;
  personid;
  resData;
  currentResId;
  letResId;
  resDataById;
  getAllResources = [];
  appliedData=false;
  loading = false;
  btnhide = false;

  constructor( public route: ActivatedRoute,public srs:StudentResourceService,public router:Router,public fb:FormBuilder) { 
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    console.log(this.currentUser);
    this.currentUserName = this.currentUser.firstname + ' ' + this.currentUser.lastname;
    //Object.assign(this, {this.single, multi})
    this.personid=this.currentUser.personid;
  }

  ngOnInit() {
    this.route.params.subscribe(res => {
      this.currentResId = res.rid;
      console.log(this.currentResId)
    });
    this.validate();
    this.getResources();
    
    /* else
    {
      this.getResourceById(this.letResId);
    } */
   
  }
  validate()
  {
    this.studForm=this.fb.group(
      {
        'rid':[this.currentResId,Validators.required],
        'firstname':['',Validators.required],
        'lastname':['',Validators.required],
        'address':['',Validators.required],
        'cellphone':['',Validators.required],
        'homephone':['',Validators.required],
        'email':['',Validators.required],
        'name_of_university':['',Validators.required],
        'campuslocation':['',Validators.required],
        'field':['',Validators.required],
        'officephone':['',Validators.required],
        'program':['',Validators.required],
        'award':['',Validators.required],
        'hourspracticum':['',Validators.required],
        'days_avail1':[''],
        'days_avail2':[''],
        'days_avail3':[''],
        'days_avail4':[''],
        'days_avail5':[''],
        'popfirst':['',Validators.required],
        'popsecond':['',Validators.required],
        'sec_lang':['',Validators.required],
        'langspeak':['',Validators.required],
        'speak':['',Validators.required],
        'read':['',Validators.required],
        'write':['',Validators.required],
        'motivation':['',Validators.required],
        'career':['',Validators.required],
      }
    )
  }
  
  getResources()
  {
    this.loading = true;
   this.srs.getResources(this.personid)
   .subscribe(res=>
    {
      this.loading = false;
      this.resData=res;
      console.log(this.resData)
      if(this.resData.status==1)
      {
        console.log(this.getAllResources);
        if(this.resData.data.length>0)
        {
          this.letResId=this.resData.data[0]['id'];
          this.getAllResources=this.resData.data;
          console.log(this.getAllResources);
          if(this.currentResId)
          {
            this.getResourceById(this.currentResId);
          }
          else
          {
            //this.currentResId=this.letResId;
            this.getResourceById(this.letResId);
          }

        }
      
      }
      
    })
  }

  getResourceById(rid)
  {
    this.appliedData=false;
    this.loading = true;
     this.srs.getResourceById(rid,this.personid)
     .subscribe(res=>
    {
      this.resData=res;
      console.log(res)
      if(this.resData.status==1)
      {
         this.resDataById=this.resData.data;
         
      }
      else
      {
        console.log(this.resData.message)
      }
      this.loading = false;
    })
  }
  
  navigateToView(id)
  {
    this.router.navigate(['/student-resources/'+id]);
    this.currentResId = id;
    this.getResourceById(this.currentResId);
  }

  removeResource(id) {

    swal({
      title: 'Are you sure you want to remove this?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, remove it!'
    }).then((result) => {
      if (result.value) {
        this.srs.removeResource(id,this.personid)
        .subscribe(res=>
        {
          if(res.status==1)
          {
              //alert('Resource remove from the list');
              swal(
                'Removed!',
                'Resource has been removed.',
                'success'
              )
              this.router.navigate(['/student-resources']);
              this.getResources(); 
          }
        })
      }
    })
    
  }

  showForm(rid){

    if(rid==1)
    {
      this.getSaveFormData(rid);
    }
    else{
      this.appliedData=false;
    }

  }

  applied(rid)
  {
    if(rid==1)
    {

      this.appliedData=true;
      this.getPersonInfo();
    
    }
    else
    {
      
      this.srs.resourceApplied(rid,this.personid)
      .subscribe(res=>
      {
        //console.log(res)
        if(res.status==200)
         {
          //alert('Applied for the Resource');
          swal('Successfully applied.');
          this.router.navigate(['/student-resources']);
          this.getResources(); 
          }
      });
    }
  }

  getPersonInfo()
  {
    this.srs.getPersonInfo(this.personid)
    .subscribe(res=>
    {

      this.resData=res;
      if(this.resData.status==200)
      {
        console.log(this.resData.data)
        this.studForm.controls['firstname'].setValue(this.resData.data.firstname);
        this.studForm.controls['lastname'].setValue(this.resData.data.lastname);
        this.studForm.controls['cellphone'].setValue(this.resData.data.phoneno);
        this.studForm.controls['email'].setValue(this.resData.data.email);
      }
      
    })
  }

  getSaveFormData(rid)
  {

    const body = JSON.stringify({
      rid: rid
    });

    this.srs.getSaveFormData(body).subscribe(res=>
    {
      this.appliedData=true;
      this.btnhide = true;
      let data = res.data;
      console.log(data);
      this.studForm.patchValue({
        'firstname': data.firstname, 
        'lastname': data.lastname,
        'address':data.address,
        'cellphone':data.cellphone,
        'homephone':data.homephone,
        'email':data.email,
        'name_of_university':data.name_of_university,
        'campuslocation':data.campuslocation,
        'field':data.field,
        'officephone':data.officephone,
        'program':data.program,
        'award':data.award,
        'hourspracticum':data.hourspracticum,
        'days_avail1':data.days_avail1,
        'days_avail2':data.days_avail2,
        'days_avail3':data.days_avail3,
        'days_avail4':data.days_avail4,
        'days_avail5':data.days_avail5,
        'popfirst':data.popfirst,
        'popsecond':data.popsecond,
        'sec_lang':data.sec_lang,
        'langspeak':data.langspeak,
        'speak':data.speak,
        'read':data.read,
        'write':data.write,
        'motivation':data.motivation,
        'career':data.career
      });

    });
  }

  Submit()
  {
    const formObj = this.studForm.getRawValue();
    const serializedForm = JSON.stringify(formObj);
    //console.log(serializedForm);

    this.srs.submitAppliedForm(serializedForm)
      .subscribe(res=>
      {
        //console.log(res)
        if(res.status==200)
         {
            //alert('Applied for the Resource');
            swal('Successfully applied.');
            this.router.navigate(['/student-resources']);
            this.getResources(); 
          }
      });
  }

  printDiv() {

    let divName;
    if(this.currentResId)
    {
      divName = 'printDiv'+this.currentResId
    }
    else
    {
      divName = 'printDiv'+this.letResId
    }
    //console.log(divName);
    let popupWinindow
    let innerContents = document.getElementById(divName).innerHTML;
    //console.log(innerContents);
    popupWinindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWinindow.document.open();
    popupWinindow.document.write("<html><head><style>.printpdf{margin:50px;}.printpdf .details p{margin-bottom:0; padding-bottom:0; line-height:14px;} .printpdf .details h3,.printpdf h4{color:#85b6ba;font-size:24px; text-transform: capitalize;}.printpdf h5{color: #8c8c8c; font-size: 14px; line-height: 18px; font-family: 'Roboto', sans-serif;font-weight: 600;}@page { size: auto;  margin: 0mm; }</style></head><body onload='window.print()'>" + innerContents + "</html>");
    popupWinindow.document.close();

  }

}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/student-resource/student-resource.component.ts